function openFilterDrawer() {
    document.querySelector(`div.drawer-overlay`).style.display = "block";
    document.getElementById('nbp-filter-drawer').style.left = '0';
}

function closeFilterDrawer() {
    document.querySelector(`div.drawer-overlay`).style.display = "none";
    document.getElementById('nbp-filter-drawer').style.left = '-150vh';
}

function toggleExpansion(element, type) {
    element.classList.toggle('expanded');
    const filterInner = element.parentElement.closest(".filter_inner");
    const filterTagsList = filterInner.querySelector(".filter_tags_list");
    filterTagsList.classList.toggle('expanded');
    
    const svg = document.querySelector("div.filter_inner>h3>svg#up-"+type);
    if(svg) {
        if(filterTagsList.classList.contains('expanded')) {
            svg.setAttribute("transform", "rotate(0, 0, 0)");
        } else {
            svg.setAttribute("transform", "rotate(180, 0, 0)");
        }
        
    }
}

function clearFilterTags() {
    const checkboxes = document.querySelectorAll(".filter_tags_list input[type='checkbox']");
    checkboxes.forEach(function(checkbox) {
        checkbox.checked = false;
    });
}

function filterByTags() {
    const checkboxes = document.querySelectorAll(".filter_tags_list input[type='checkbox']");

    var str = "";
    var name = "";
    checkboxes.forEach(function(checkbox) {
        if(checkbox.checked) {
            if(name == "") {
                const label = checkbox.parentElement.querySelector("label");
                name = label.textContent;
            }
            str == "" ? str = checkbox.id : str = str + "+" + checkbox.id;
        }
    });

    if(str == "") {
        window.location.href = "/blogs/features";
    } else {
        window.location.href = "/blogs/features/tagged/"+str;
    }
}

document.addEventListener("DOMContentLoaded", function() {
    const checkboxes = document.querySelectorAll(".filter_tags_list input[type='checkbox']");
    const headerText = document.querySelector(".nbp-all-articles>.section-heading");
    var name = "";
    checkboxes.forEach(function(checkbox) {
        if(checkbox.checked) {
            if(name == "") {
                const label = checkbox.parentElement.querySelector("label");
                name = label.textContent;
                headerText.textContent = name + " Articles";
            }
            return;
        }
    });
});
